import { Dimension, Interval, Period, TargetIOType } from './Constants'
import dayjs from 'dayjs'

const dateFormat = 'YYYY-MM-DD'

export class IntervalReportQuery {
  constructor(item = {}) {
    const {
      insertionOrderIds = [],
      dimension = Dimension.INSERTION_ORDER,
      interval = Interval.DAILY,
      period = Period.TOTAL,
      startDate = null,
      endDate = null,
      isIncludeBudget = false,
      isIncludeCreative = false,
    } = item
    this.insertionOrderIds = insertionOrderIds
    this.insertionOrderAddedList = insertionOrderIds.map(id => {
      return {
        id: id,
        name: '',
      }
    })
    this.dimension = dimension
    this.interval = interval
    if (Object.values(Period).includes(period)) {
      this.period = period
      this.startDate = startDate
      this.endDate = endDate
    } else {
      this.period = Period.SELECT
      this.startDate = period.startDate
      this.endDate = period.endDate
    }
    this.isIncludeBudget = isIncludeBudget
    this.isIncludeCreative = isIncludeCreative
    this.targetIOType =
      this.insertionOrderAddedList.length === 0
        ? TargetIOType.ALL
        : TargetIOType.SELECT
  }

  isPeriodSelect() {
    return this.period === Period.SELECT
  }

  isInsertionOrderBudgetInterval() {
    return this.interval === Interval.INSERTION_ORDER_BUDGET
  }

  setDefaultDate() {
    this.startDate = dayjs(new Date())
      .startOf('month')
      .format(dateFormat)
    this.endDate = dayjs(new Date())
      .endOf('month')
      .format(dateFormat)
  }

  resetDate() {
    this.startDate = null
    this.endDate = null
  }

  isValid(isAdminUser) {
    return (
      Object.values(Dimension).includes(this.dimension) &&
      Object.values(Interval).includes(this.interval) &&
      Object.values(Period).includes(this.period) &&
      this.isValidInsertionOrderIds(isAdminUser) &&
      this.isValidPeriodDate()
    )
  }

  isValidInsertionOrderIds(isAdminUser) {
    if (isAdminUser) {
      if (this.targetIOType === TargetIOType.SELECT) {
        return this.insertionOrderAddedList.length > 0
      }
    } else {
      return this.insertionOrderAddedList.length > 0
    }
    return true
  }

  isValidPeriodDate() {
    if (this.isPeriodSelect()) {
      return this.startDate !== null
    } else {
      return this.startDate === null && this.endDate === null
    }
  }
}
